// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"MetricTiles-primaryButton-2kjE07","cards":"MetricTiles-cards-1yhkWw"};